import Network from "../../../../infrastructure/js/modules/network";

export function fetchCustomerOrders() {
  return Network.get('customer-orders');
}
